/* tslint:disable:max-line-length */
/* tslint:disable:no-trailing-whitespace */
/* tslint:disable:eofline */
import * as React from 'react';
import pure from 'recompose/pure';

class CountryFlagSeIcon extends React.Component<{style: any}> {
    render() {
        return (
            <svg  width={24} height={24} viewBox="0 0 640 480" {...this.props}>
              <path fill="#066aa7" d="M0 0h640v480H0z"/>
              <path fill="#fecc00" d="M0 192h640v96H0z"/>
              <path fill="#fecc00" d="M176 0h96v480h-96z"/>
            </svg>
        );
    }
}

const PureIcon = pure(CountryFlagSeIcon);
PureIcon.displayName = 'CountryFlagSeIcon';
export default PureIcon;
